"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePickupPoints = exports.PickupPointsProvider = void 0;
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _swrConfig = require("../../constants/swrConfig");
var _usePickupPoints = require("./usePickupPoints");
var _jsxRuntime = require("react/jsx-runtime");
const pickupPointsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const PickupPointsProvider = ({
  enabled,
  children
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    clearSearch,
    isMapInfoOpen,
    loadMore,
    loadedPickupPoints,
    loading,
    pickupPoints,
    search,
    selectedPickupPointId,
    setIsMapInfoOpen,
    setSelectedPickupPointId,
    totalRecords
  } = (0, _usePickupPoints.usePickupPoints)(enabled);
  const selectedPickupPoint = (0, _react.useMemo)(() => pickupPoints.find(({
    deliveryChannelId
  }) => deliveryChannelId === selectedPickupPointId), [pickupPoints, selectedPickupPointId]);
  const {
    data: addressFormat
  } = (0, _staticApiClientReact.useGetTenantAddressFormat)(tenant, 'SingleLine', {
    swr: _swrConfig.basicSwrOptions
  });
  const value = (0, _react.useMemo)(() => ({
    addressFormat,
    clearSearch,
    isMapInfoOpen,
    loadedPickupPoints,
    loading,
    pickupPoints,
    search,
    selectedPickupPoint,
    selectedPickupPointId,
    setIsMapInfoOpen,
    setSelectedPickupPointId,
    totalRecords,
    loadMore
  }), [addressFormat, clearSearch, isMapInfoOpen, loadedPickupPoints, loading, pickupPoints, search, selectedPickupPoint, selectedPickupPointId, setIsMapInfoOpen, setSelectedPickupPointId, totalRecords, loadMore]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(pickupPointsContext.Provider, {
    value: value,
    children: children
  });
};
exports.PickupPointsProvider = PickupPointsProvider;
const usePickupPoints = () => {
  const ctx = (0, _react.useContext)(pickupPointsContext);
  if (!ctx) {
    throw new Error('usePickupPoints must be used within a PickupPointsProvider');
  }
  return ctx;
};
exports.usePickupPoints = usePickupPoints;